import { useEffect, useState } from "react";
import { Constant } from "../../helper/constant";
import { useAppContext } from "../../context/app.context";
import { getIndustryList } from "../../service/ai.service";
import { getStorageData } from "../../service/storage.service";

const CurrencyType = {
  dollar: "USD",
  pound: "GBP",
  euro: "EUR",
};
const UnsignedForm = () => {
  const { calculateUnsignedRevenue } = useAppContext();

  const [industryId, setIndustryId] = useState('');
  const [industries, setIndustries] = useState([]);
  const [revenue, setRevenue] = useState(
    Constant.REVENUE_RAGE.MIN
  );
  const [revenueType, setRevenueType] = useState(CurrencyType.dollar);
  const [inventory, setInventory] = useState(
    Constant.INVENTORY_RAGE.MIN
  );
  const [inventoryType, setInventoryType] = useState(CurrencyType.dollar);
  const [count, setCount] = useState(
    Constant.EMPLOYEE_RAGE.MIN
  );
  const [form, setForm] = useState({ error: { valid: false } });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getIndustryList()
      .then(res => {
        if (res && res.length > 0) {
          setIndustries(res);
        }
      }).catch(e => e);

    const data = getStorageData(Constant.STORAGE_KEYS.USER_INFO) || {};
    if (data && data.userInfo) {
      setIndustryId(data.userInfo.industry);
      setInventory(data.userInfo.inventory);
      setRevenue(data.userInfo.revenue);
      setRevenueType(data.userInfo.revenue_currency);
      setInventoryType(data.userInfo.inventory_currency);
      setCount(data.userInfo.employee_count)
    }
    return () => { }
  }, []);

  // useEffect(() => {
  //   if (industryId) {
  //     setRevenue(Constant.REVENUE_RAGE.MIN);
  //     setCount(Constant.EMPLOYEE_RAGE.MIN);
  //     setInventory(Constant.INVENTORY_RAGE.MIN)
  //   }
  // }, [industryId]);

  const handleValidation = () => {
    let formIsValid = true;
    let error = {};

    if (!industryId) {
      formIsValid = false;
      error["industryId"] = "Industry required.";
    }

    if (!revenue) {
      formIsValid = false;
      error["revenue"] = "Revenue is required.";
    }

    if (!count) {
      formIsValid = false;
      error["count"] = "Employee Count required.";
    }

    setForm({ error });
    return formIsValid;
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if ((revenue && count, inventory)) {
        onCalculateRevenueSubmited();
      }
    }, 100);

    return () => clearTimeout(delayDebounceFn);
  }, [revenue, count, inventory]);

  const onCalculateRevenueSubmited = () => {
    if (handleValidation()) {
      setLoading(true);
      const data = {
        industryId,
        revenue,
        count,
        inventory,
      };
      calculateUnsignedRevenue(data);
    }
  };

  const render = () => {
    return (
      <div className="calulatorbox py-4 px-5">
        <h5 className="mb-3">Input Your Data</h5>
        <form noValidate>
          <div className="form-group">
            <label className="text-blue d-block">
              Select Industry<span className="text-danger">*</span>
            </label>
            <div className="d-flex justify-align-content-start align-items-center">
              <select
                className={`form-control capitalize ${form.error["industryId"] ? "error-br" : ""}`}
                value={industryId}
                onChange={e => setIndustryId(e.target.value)}
              >
                <option value="" disabled>
                  Select Industry...
                </option>
                {industries.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.industry_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="range-sliders">
            <div className="form-group mb-5">
              <label className="text-blue d-block">
                Revenue (in Millions)<span className="text-danger">*</span>
              </label>
              <div className="form-check-inline mb-2">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="revenueradio"
                    value={CurrencyType.dollar}
                    checked={revenueType === CurrencyType.dollar}
                    onChange={(e) => setRevenueType(e.target.value)}
                  />
                  $
                </label>
              </div>
              <div className="form-check-inline">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="revenueradio"
                    value={CurrencyType.pound}
                    checked={revenueType === CurrencyType.pound}
                    onChange={(e) => setRevenueType(e.target.value)}
                  />
                  £
                </label>
              </div>
              <div className="form-check-inline">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="revenueradio"
                    value={CurrencyType.euro}
                    checked={revenueType === CurrencyType.euro}
                    onChange={(e) => setRevenueType(e.target.value)}
                  />
                  €
                </label>
              </div>
              <div
                className="range-slider-group d-flex flex-column"
                data-min={`${Constant.REVENUE_RAGE.MIN}M`}
                data-max={`${Constant.REVENUE_RAGE.MAX}M`}
              >
                <input
                  type="range"
                  min={Constant.REVENUE_RAGE.MIN}
                  max={Constant.REVENUE_RAGE.MAX}
                  step={Constant.REVENUE_RAGE.STEP}
                  data-color="#f00"
                  className="range-slider numbrings order-2 range-slider-red"
                  id="range-slider-red"
                  value={revenue}
                  onChange={e => setRevenue(e.target.value)}
                />
                <input
                  type="number"
                  min={Constant.REVENUE_RAGE.MIN}
                  max={Constant.REVENUE_RAGE.MAX}
                  step={Constant.REVENUE_RAGE.STEP}
                  className="input-slider form-control mb-4 order-1 input-slider-red"
                  id="input-slider-red"
                  style={{ borderColor: form.error["revenue"] ? "red" : "" }}
                  value={revenue}
                  onChange={e => setRevenue(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-5">
              <label className="text-blue d-block">
                No. of Employee <span className="text-danger">*</span>
              </label>
              <div
                className="range-slider-group d-flex flex-column"
                data-min={Constant.EMPLOYEE_RAGE.MIN}
                data-max={Constant.EMPLOYEE_RAGE.MAX}
              >
                <input
                  type="range"
                  min={Constant.EMPLOYEE_RAGE.MIN}
                  max={Constant.EMPLOYEE_RAGE.MAX}
                  value={count}
                  data-color="#f00"
                  className="range-slider numbrings order-2 range-slider-red"
                  id="range-slider-red"
                  style={{ borderColor: form.error["count"] ? "red" : "" }}
                  onChange={e => setCount(e.target.value)}
                />
                <input
                  type="number"
                  min={Constant.EMPLOYEE_RAGE.MIN}
                  max={Constant.EMPLOYEE_RAGE.MAX}
                  value={count}
                  onChange={e => setCount(e.target.value)}
                  className="input-slider form-control mb-4 order-1 input-slider-red"
                  id="input-slider-red"
                />
              </div>
            </div>
            <div className="form-group mb-5">
              <label className="text-blue d-block">
                Inventory (in Millions)
              </label>
              <div className="form-check-inline mb-2">
                <label className="form-check-label" htmlFor="">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="inventoryradio"
                    value={CurrencyType.dollar}
                    checked={inventoryType === CurrencyType.dollar}
                    onChange={(e) => setInventoryType(e.target.value)}
                  />
                  $
                </label>
              </div>
              <div className="form-check-inline">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="inventoryradio"
                    value={CurrencyType.pound}
                    checked={inventoryType === CurrencyType.pound}
                    onChange={(e) => setInventoryType(e.target.value)}
                  />
                  £
                </label>
              </div>
              <div className="form-check-inline">
                <label className="form-check-label">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="inventoryradio"
                    value={CurrencyType.euro}
                    checked={inventoryType === CurrencyType.euro}
                    onChange={(e) => setInventoryType(e.target.value)}
                  />
                  €
                </label>
              </div>
              <div
                className="range-slider-group d-flex flex-column"
                data-min={`${Constant.INVENTORY_RAGE.MIN}M`}
                data-max={`${Constant.INVENTORY_RAGE.MAX}M`}
              >
                <input
                  type="range"
                  min={Constant.INVENTORY_RAGE.MIN}
                  max={Constant.INVENTORY_RAGE.MAX}
                  step={Constant.INVENTORY_RAGE.STEP}
                  data-color="#f00"
                  className="range-slider numbrings order-2 range-slider-red"
                  id="range-slider-red"
                  value={inventory}
                  onChange={e => setInventory(e.target.value)}
                />
                <input
                  type="number"
                  min={Constant.INVENTORY_RAGE.MIN}
                  max={Constant.INVENTORY_RAGE.MAX}
                  step={Constant.INVENTORY_RAGE.STEP}
                  value={inventory}
                  onChange={e => setInventory(e.target.value)}
                  className="input-slider form-control mb-4 order-1 input-slider-red"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };

  return render();
};

export default UnsignedForm;
